import * as types from "./actionTypes";
import { SnackBarProps } from "../../Utils/SnackBarUtils";

export function dispatchActionData(type, data) {
  return { type: type, data: data };
}

//to open snack bar
export function setSnackBar(data) {
  return function (dispatch) {
    dispatch(dispatchActionData(types.SET_SNACKBAR_STATUS, data));
  };
}
//to open success snack bar
export function openSuccessSnackBar(message) {
  return function (dispatch) {
    const snackBarObj = new SnackBarProps(message, "success");
    dispatch(dispatchActionData(types.SET_SNACKBAR_STATUS, snackBarObj));
  };
}
//to open error snack bar
export function openErrorSnackBar(message) {
  return function (dispatch) {
    const snackBarObj = new SnackBarProps(message, "error");
    dispatch(dispatchActionData(types.SET_SNACKBAR_STATUS, snackBarObj));
  };
}
//to close snack bar
export function clearSnackBar() {
  return function (dispatch) {
    dispatch(dispatchActionData(types.CLEAR_SNACKBAR));
  };
}
